import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { getAllPathParams } from '@workspaces/utils/get-all-path-params';

@Component({
  template: ''
})
export abstract class EditComponent implements OnInit {
  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly snackbar: MatSnackBar,
    protected readonly router: Router
  ) {}
  protected workspaceId = '';
  protected params: Record<string, string> = {};

  ngOnInit(): void {
    this.params = getAllPathParams(this.route.snapshot);
    this.workspaceId = this.params['workspaceId'] ?? 'null';
    if (!this.workspaceId.length) {
      this.snackbar.open('Invalid url. You will be redirected.', 'Dismiss', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
      setTimeout(() => {
        this.router.navigate(['/workspaces']);
      }, 3000);
      throw Error('Invalid url. Missing workspaceId');
    }
  }
}
